<script setup>
import { computed } from "vue";
import { useField } from "vee-validate";
import { ErrorMessage } from ".";
import { validationModes } from "./validation-modes";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  autocomplete: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  validationMode: {
    type: String,
    default: "eager",
  },
});

const { value, errorMessage, meta, handleChange, handleBlur } = useField(
  props.name,
  {},
  {
    validateOnValueUpdate: false,
  }
);

const handlers = computed(() => {
  const on = {
    blur: handleBlur,
    input: [(e) => handleChange(e, false)],
    change: undefined,
  };

  const triggers = validationModes[props.validationMode]({
    errorMessage,
    meta,
  });

  triggers.forEach((trigger) => {
    if (Array.isArray(on[trigger])) {
      on[trigger].push(handleChange);
    } else {
      on[trigger] = handleChange;
    }
  });

  return on;
});
</script>

<template>
  <div>
    <FormInputLabel v-if="props.label?.length" :for="props.name">
      {{ props.label }}
    </FormInputLabel>
    <div class="relative">
      <Textarea
        v-model="value"
        :name="props.name"
        :placeholder="props.placeholder"
        :autocomplete="props.autocomplete"
        auto-resize
        :class="[errorMessage?.length && 'error-state', 'textarea']"
        rows="4"
        v-on="handlers"
      />
    </div>
    <ErrorMessage :message="errorMessage" />
  </div>
</template>

<style scoped>
.textarea {
  width: 100%;
}
.error-state {
  border-color: red;
  &:hover {
    border-color: red;
  }
}
</style>
